/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { getRiskGradient, riskColors } from '../screens/View/helper';
import { Gauge } from '@antv/g2plot';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

const labelsText = [
  'None',
  'Very Low',
  'Low',
  'Medium',
  'High',
  'Very High',
];

export const getLabels = (n, t) => t(labelsText[n]);

export const labels = {
  5: i18next.t(labelsText[5]),
  4: i18next.t(labelsText[4]),
  3: i18next.t(labelsText[3]),
  2: i18next.t(labelsText[2]),
  1: i18next.t(labelsText[1]),
  0: i18next.t(labelsText[0]),
};

export default function useRiskGauge({
  container,
  score,
  subScore,
  showLabel = true,
  showLabelInScore = false,
}) {
  const [mainGraph, setMainGraph] = useState(null);
  const [color, setColor] = useState('transparent');
  const [roundScore, setRoundScore] = useState(0);
  const { t } = useTranslation();

  const getSubscoreAvg = () => {
    if (subScore && Object.keys(subScore).filter(key => !subScore[key]).length === 0) {
      return Object.values(subScore).reduce((a, b) => {
        return a + b;
      }, 0) / Object.keys(subScore).length;
    }
    return 0;
  }

  useEffect(() => {
    const mainScore = subScore ? getSubscoreAvg() : score.score;
    const roundScore = Math.round(mainScore);
    const percent = mainScore ? (mainScore * 20) / 100 : 0;
    let graphColor = percent ? `l(0) ${getRiskGradient(roundScore)}` : riskColors[0];
    setColor(riskColors[roundScore]);
    setRoundScore(roundScore);
    if (container.current) {

      if (mainGraph) {
        mainGraph.update({
          percent,
          range: {
            color: graphColor,
          },
          statistic: {
            title: {
              offsetY: showLabelInScore ? -30 : -8,
              style: {
                fontSize: showLabelInScore ? '16px' : '28px',
                color: '#000000',
              },
              formatter: () => showLabelInScore ?
                `<p style="color: ${riskColors[roundScore]}; text-align: center;">
                <span style="color: black">
                ${(mainScore).toFixed(2)}
                </span>
                <br>
                ${getLabels(roundScore, t)}
              </p>`
                : `<p style="color: ${riskColors[roundScore]}">${(mainScore).toFixed(2)}</p>`,
            },
            formatter: () => showLabel ? `<p style="color: ${riskColors[roundScore]}">
            ${(mainScore).toFixed(2)}
            </p>` : `
              <div style="display: flex; flex-direction: column;">
              <p style="font-size: 14px; margin-bottom: 0px;">${(mainScore).toFixed(2)}</p>
              <p style="font-size: 14px; margin-bottom: 0px; color: ${riskColors[roundScore]}">${getLabels(roundScore, t)}</p>
              </div>
            `,
          },
        })
      } else {
        const gauge = new Gauge(container.current, {
          height: 170,
          percent,
          range: {
            color: graphColor,
          },
          startAngle: Math.PI,
          endAngle: 2 * Math.PI,
          innerRadius: 0.7,
          indicator: null,
          animation: false,
          statistic: {
            title: {
              offsetY: showLabelInScore ? -30 : -8,
              style: {
                fontSize: showLabelInScore ? '20px' : '28px',
                color: '#000000',
              },
              formatter: () => showLabelInScore ?
                `<p style="color: ${riskColors[roundScore]}; text-align: center;">
                <span style="color: black">
                ${(mainScore).toFixed(2)}
                </span>
                <br>
                ${getLabels(roundScore, t)}
              </p>`
                : `<p style="color: ${riskColors[roundScore]}">${(mainScore).toFixed(2)}</p>`,
            },

          },
        });
        gauge.render();
        setMainGraph(gauge);
      }
    }
  }, [container, score, subScore]);

  return { color, roundScore };
}
